import { render, staticRenderFns } from "./OrderFoodManagement.vue?vue&type=template&id=848991ce&scoped=true"
import script from "./OrderFoodManagement.vue?vue&type=script&lang=js"
export * from "./OrderFoodManagement.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodManagement.vue?vue&type=style&index=0&id=848991ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848991ce",
  null
  
)

export default component.exports